import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LoadTop from '../components/LoadTop';
import BackToTop from '../components/BackToTop';
import HomeSix from "./HomeSix";
// inner pages
import ServiceTwo from "../inner/ServiceTwo";
import AboutUs from "../inner/AboutUs";
import ContactUs from '../inner/ContactUs';
import TermsAndConditions from '../inner/TermsAndConditions';




function RouterPage() {
    return (
        <div>
            <Router>
                <LoadTop />
                <Routes>
                    <Route path="/" element={<HomeSix />}></Route>
                    <Route path="/about-us" element={<AboutUs />}></Route>
                    <Route path="/services" element={<ServiceTwo />}></Route>
                    <Route path="/contactus" element={<ContactUs />}></Route>
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />}></Route>
                </Routes>
                <BackToTop />
            </Router>
        </div>
    )
}

export default RouterPage